import * as React from 'react';
import { Datagrid, ImageField, ListProps, TextField } from 'react-admin';
import './BillboardDatagrid.scss';
import { TranslateField } from '../components/TranslateField';

export const BillboardDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="billboards-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/><ImageField source="featuredImageUrl" label="FEATURED_IMAGE"/>
			<TextField source="title" label="TITLE"/>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
